export default "__VITE_ASSET__D6k36BxM__"